import { VatExemption } from "../../../ProductService/BonificoOrder/BonificoOrderDTO.ts";
import type { OrderInvoiceInfoDTO } from "../../../Stripe/StripeOrderDTO.ts";

type AmountInCentsDTO = {
  amount: number;
  currency: string;
};

export enum PaidAmountSource {
  Stripe = "stripe",
  OrderHistory = "order_history",
}

export type InstallmentsSettlementSummaryDTO = {
  totalAmountInCents: AmountInCentsDTO;
  amountAlreadyPaidInCents: AmountInCentsDTO;
  remainingAmountInCents: AmountInCentsDTO;
  paidAmountSource: PaidAmountSource;
  blockingReason?: string;
};

export type RequestedOrderInvoiceInfoDTO = Extract<
  OrderInvoiceInfoDTO,
  { requested: true }
>;

export type SettleInstallmentsRequest = {
  amountInCents: number;
  receiptDate: string;
  invoiceInfo: RequestedOrderInvoiceInfoDTO;
  vatExemption?: VatExemption;
  bonificoDraftOrderId?: string;
};

export function getInstallmentsSettlementErrorMessage(
  e: unknown,
  fallback: string,
): string {
  const err = e as { response?: { data?: { message?: string } } };
  return err.response?.data?.message ?? fallback;
}
